export class User {
    constructor(qonversionId, identityId) {
        this.qonversionId = qonversionId;
        this.identityId = identityId;
    }
}
//# sourceMappingURL=User.js.map